module.exports = __webpack_public_path__ + "f55498e2576c46235de48e6e3d4110cc.svg";